import React, { useState } from "react";
import { IoClose } from "react-icons/io5";
import { useTranslation } from "react-i18next";

const ApproveActionModal = ({ isOpen, onClose, onConfirm, estimate, title }) => {
    const { t } = useTranslation();
    const [remark, setRemark] = useState("");

    if (!isOpen || !estimate) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        // Passing the ID and remark back to the handleConfirmApproval in ApprovePlanEstimate.jsx
        onConfirm(estimate.id, remark);
        setRemark(""); // Clear state for the next approval action
    };

    return (
        <div className="staff-modal-overlay">
            <div className="staff-modal" style={{ width: '600px', maxWidth: '95%' }}>
                
                {/* Modal Header - Consistent with image_d18446.png */}
                <div className="staff-modal-header py-2 flex justify-between items-center px-4" style={{ background: '#fff', borderBottom: '1px solid #e5e7eb' }}>
                    <div className="staff-modal-title text-gray-700 font-bold text-sm">
                        {title || t('pageTitles.approvePlanEstimate')}
                    </div>
                    <button className="text-gray-500 hover:text-red-500 transition-colors" onClick={onClose}>
                        <IoClose size={20} />
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="staff-form-body p-8">
                        {/* Work Name Context */}
                        <div className="mb-6 bg-blue-50 p-3 rounded-lg border border-blue-100">
                            <p className="text-xs text-blue-800 font-semibold uppercase tracking-wider mb-1">
                                {t('forms.planEstimate.workName')}
                            </p>
                            <p className="text-sm font-bold text-gray-900">
                                {estimate.nameOfWork}
                            </p>
                        </div>

                        {/* Remark Field - Mandatory as per image_d18446.png */}
                        <div className="flex flex-col gap-2">
                            <label className="text-xs font-bold text-gray-700">
                                Remark <span className="text-red-500">(*)</span> :
                            </label>
                            <textarea 
                                className="w-full h-32 p-3 border border-gray-300 rounded focus:ring-2 focus:ring-blue-400 focus:border-transparent outline-none text-sm transition-all resize-none"
                                placeholder="Enter approval comments or instructions..."
                                value={remark}
                                onChange={(e) => setRemark(e.target.value)}
                                required
                            />
                        </div>
                    </div>

                    {/* Action Footer - Centered Button as per image_d18446.png */}
                    <div className="staff-form-footer border-t p-4 flex justify-center bg-gray-50">
                        <button 
                            type="submit" 
                            className="staff-btn-save"
                        >
                            {t('common.save')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ApproveActionModal;